import React from 'react';

import './Question.scss';

const Question = props => {
    return (
        <div className="Question"
        id={props.q_id}> 
            {props.question}
        </div>
    )
}

export default Question;